export default "__VITE_ASSET__BtkQv8TY__"